import { FaWhatsapp } from "react-icons/fa";
import styles from "./Whatsapbut.module.css";

const WhatsAppButton = () => {
  const phoneNumber = "918886060799"; // your whatsapp number

  const handleClick = () => {
    window.open(
      `https://api.whatsapp.com/send?phone=${phoneNumber}`,
      "_blank"
    );
  };

  return (
    <button className={styles.whatsappBtn} onClick={handleClick}>
      <FaWhatsapp />
    </button>
  );
};

export default WhatsAppButton;